import { MenuItem } from "@mui/material";
import { Select } from "@mui/material";
import { useEffect, useState } from "react";

function flattenTree(tree) {
  const result = [];

  function traverse(node) {
    // result.push({ id: node.id, name: node.name });
    result.push(node);

    if (node.children) {
      for (let child of node.children) {
        traverse(child);
      }
    }
  }

  for (let node of tree) {
    traverse(node);
  }

  return result;
}


function TreeSelect({ value, data, maxLevel, onChange, topLabel = '', ...rest }) {

  const [list, setList] = useState([]);
  const [item, setItem] = useState({});

  // console.log(item)

  useEffect(() => {
    if (!data || !data.length) return;

    let items = flattenTree(data).map(node => {
      return {
        id: node.id,
        name: '|-----'.repeat(node.level) + node.name,
        pid: node.pid,
        level: node.level,
        hasChildren: !!node.children
      }
    });

    if (maxLevel != undefined) {
      items = items.filter(it => it.level <= maxLevel);
      // console.log(maxLevel, items)
    }

    if (value) {
      // console.log(value, items)
      setItem(items.find(it => it.id == value));
    }
    setList(items);

  }, [data]);

  return (
    <Select value={value}
      disabled={list.length == 0}
      // label={topLabel}
      onChange={(e) => onChange(e.target.value)} style={{ width: 250, height: 44 }}
      {...rest}
    >
      {list.map((item, idx) => (
        <MenuItem key={idx} value={item.id} name={item.name}>
          {item.name}
        </MenuItem>
      ))}
    </Select>
  )
}

export default TreeSelect;